import { render, staticRenderFns } from "./MoreInfoIcon.vue?vue&type=template&id=327b2b41"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327b2b41')) {
      api.createRecord('327b2b41', component.options)
    } else {
      api.reload('327b2b41', component.options)
    }
    module.hot.accept("./MoreInfoIcon.vue?vue&type=template&id=327b2b41", function () {
      api.rerender('327b2b41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MoreInfoIcon.vue"
export default component.exports